var ipIsInternational= window.location.hostname=="auth-intl.huaweicloud.com";
(function() {
    window.load3rdScript = function(url, cache) {

        setTimeout(function() {

            var t = document.createElement('script');
            var f = document.getElementsByTagName('script')[0];
            t.async = true;
            t.src = url;
            f.parentNode.insertBefore(t, f)

        }, 0);

    }
    window.statistics = function(cnt) {
    	cnt && cnt.cloudbi && window.load3rdScript('https://res.hc-cdn.com/bi/uba.js?'+Math.random());
    }
})();

(function (url,win,doc,myName) {
    win[myName] = win[myName] || function(){
            (win[myName].q = win[myName].q || []).push(arguments);
        };
}('/authui/public/custom/js/gaTools/ha_f.js',window, document,'ha'));

window.sendToGA = function() {
    if(ipIsInternational){
        ga('create', 'UA-55836286-39', 'auto');
    }
    else{
        ga('create', 'UA-55836286-1', 'auto');
    }
    var splitUrl = window.location.href.split('#');
    var funName = splitUrl[0].indexOf('?') != -1 ? "&location=" : "?location=";
    var newUrl = splitUrl[0] + funName + splitUrl[1].split('/')[1]
            + _IAMLocation;
    ga('set', 'location', newUrl);
    ga('send', 'pageview');
};

window.sendToGA4User = function(userId) {
    var tracker;
    if(ipIsInternational){
        tracker=ga.create('UA-55836286-39', {'userId' : userId, 'name' : 'tracker_user'});
    }
    else{
        tracker=ga.create('UA-55836286-1', {'userId' : userId, 'name' : 'tracker_user'});
    }
    var splitUrl = window.location.href.split('#');
    var funName = splitUrl[0].indexOf('?') != -1 ? "&location=" : "?location=";
    var newUrl = splitUrl[0] + funName + splitUrl[1].split('/')[1]
            + _IAMLocation;
    tracker.set('location', newUrl);
    tracker.send('pageview', {
        'dimension1' : userId,
        'dimension2' : 'RegisterSuccess',
        'dimension3' : getServiceParamValue()
    });
};

window.sendToGA4VmallUser = function(userId) {
    var tracker;
    if(ipIsInternational){
        tracker=ga.create('UA-55836286-39', {'userId' : userId, 'name' : 'tracker_user'});
    }
    else{
        tracker=ga.create('UA-55836286-1', {'userId' : userId, 'name' : 'tracker_user'});
    }
    var splitUrl = window.location.href.split('#');
    var funName = splitUrl[0].indexOf('?') != -1 ? "&location=" : "?location=";
    var newUrl = splitUrl[0] + funName + splitUrl[1].split('/')[1]
            + _IAMLocation;
    tracker.set('location', newUrl);
    tracker.send('pageview', {
        'dimension5' : userId,
        'dimension6' : 'vmallRegisterSuccess',
        'dimension4' : getServiceParamValue()
    });
};



window.getServiceParamValue = function() {
    var result = window.location.search;
    if(result==null || result==""){
        return "";
    }

    var i = result.indexOf("?service=");
    if(i==-1){
        i = result.indexOf("&service=");
    }

    if(i==-1){
        return "";
    }

    result = result.substring(i+9);

    i = result.indexOf('&');
    if(i!=-1){
        result = result.substring(0, i);
    }

    if(result.indexOf("https%3A%2F")==0 || result.indexOf("http%3A%2F")==0){
        result = decodeURIComponent(result);
    }

    return result;
};

window.initialCloudBI = function(domainId) {
    try {
        if (domainId) {
            if(ipIsInternational) {
                init("2", "c9770c4dac06fe3b76ec9c7ad47273d0", "UA-55836286-39", {UserAccount: domainId, isdebug: 'true'});
            }
            else {
                init("2", "c9770c4dac06fe3b76ec9c7ad47273d0", "UA-55836286-1", {UserAccount: domainId, isdebug: 'true'});
            }
        }else {
            if(ipIsInternational){
                init("2", "c9770c4dac06fe3b76ec9c7ad47273d0", "UA-55836286-39", {UserAccount:'host',isdebug:'true'});
            }
            else{
                init("2", "c9770c4dac06fe3b76ec9c7ad47273d0", "UA-55836286-1", {UserAccount:'host',isdebug:'true'});
            }

        }
    }catch(e) {

    }
}

window.send2CloudBI = function(a, b, c, d, jsonParams) {

    jsonParams=  $.extend({"Appkey":"c9770c4dac06fe3b76ec9c7ad47273d0"},jsonParams||{})
    
    try {
        onEvent(a, b, c, d, jsonParams);
    }catch(e) {

    }
}

window.addPageView4CloudBI = function(pageName, jsonParams) {

    jsonParams=  $.extend({"Appkey":"c9770c4dac06fe3b76ec9c7ad47273d0"},jsonParams||{})
    try {
        onPageView(pageName, jsonParams);
    }catch(e) {
    }
}




// WEBPACK FOOTER //
// ./public/hws/js/gaTools.js